import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/member',
    name: 'Member',
    component: () => import('../views/Member.vue')
  },
  {
    path: '/sponsor',
    name: 'Sponsor',
    component: () => import('../views/Sponsor.vue')
  },
  {
    path: '/works',
    name: 'Works',
    component: () => import('../views/Works.vue')
  },
  {
    path: '/proposal',
    name: 'Proposal',
    component: () => import('../views/Proposal.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },

  {
    path: '/union',
    name: 'Union',
    component: () => import('../views/Union.vue')
  },
  {
    path: '/company',
    name: 'Company',
    component: () => import('../views/Company.vue')
  },
  {
    path: '/forumArticles',
    name: 'forumArticles',
    component: () => import('../views/ForumArticles1.vue')
  },
  {
    path: '/forumArticles/forumArticles2',
    name: 'forumArticles2',
    component: () => import('../views/ForumArticles2.vue')
  },
  {
    path: '/aboutAlliances',
    name: 'aboutAlliances',
    component: () => import('../views/AboutAlliances.vue')
  },
  {
    path: '/aboutAlliances/aboutAlliances1',
    name: 'aboutAlliances1',
    component: () => import('../views/AboutAlliances1.vue')
  },
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  document.documentElement.scrollTop = 0
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next()
})

export default router